import { useRef, useEffect } from 'react';
import { useSingleton, useUpdate, useSafeInit } from '@tencent/glue-react-use';
export function usePartialState(creator) {
    var model = useSingleton(creator);
    var update = useUpdate();
    var stateRef = useRef();
    useEffect(function () {
        if (model.needScroll) {
            model.autoScroll();
        }
    }, [model.needScroll]);
    useSafeInit(function () {
        var onRefresh = function () {
            update();
        };
        model.addListener('onUpdate', onRefresh);
        return function () {
            model.removeListener('onUpdate', onRefresh);
        };
    });
    return [stateRef.current, model];
}
